export enum RouteNamesGeneral {
  HOME = '/',
  NOT_FOUND = '/404',
  OTHER = '*',
}

export enum RouteNamesNonAuth {
  LOGIN = '/login',
  REGISTER = '/register',
  CLIENT_REGISTER = '/client-register',
  RESET_PASSWORD = '/reset-password',
  REGISTER_USER = '/register-user',
  REQUEST_NEW_PASSWORD = '/request-new-password',
}

export enum RouteNamesAuth {
  DASHBOARD = '/dashboard',
  CAMPAIGNS = '/campanhas',
  PRODUCT = '/produto/:slug',
  INFORMATIONS = '/informacoes/:slug',
  DOCUMENTS = '/informacoes/documentos',
  EXTRACTS = '/informacoes/extratos',
  CLAIMS_PROCESS = '/sinistros/:slug',
  CLAIMS = '/sinistros/estado-sinistros',
  PROFILE = '/profile',
  PROFILE_BROKER = '/profile-broker',
  TRAININGS = '/formacoes',
  PAST_TRAININGS = '/formacoes-historico',
  TUTORIALS = '/tutoriais',
  CERTIFICATES = '/certificados',
  QUOTATIONS = '/cotacoes',
  QUOTATION_DETAILS = '/cotacoes/:policyNo/:eventNo',
  POLICIES = '/apolices',
  POLICY_DETAILS = '/apolices/:policyNo',
  INVOICES = '/faturas',
  INVOICE_DETAILS = '/faturas/:receiptNo',
  SIMULATOR = '/simulador/:slug',
  PAYMENTS = '/informacoes/:slug',
  BACKOFFICE_DASHBOARD = '/admin',
  BACKOFFICE_BROKERS = '/admin/brokers',
  BACKOFFICE_BROKER_DETAILS = '/admin/brokers/:id',
  BACKOFFICE_PRODUCT_CATEGORIES = '/admin/categorias-de-produtos',
  BACKOFFICE_PRODUCTS = '/admin/produtos',
  BACKOFFICE_PRODUCT_DETAILS = '/admin/produtos/:id',
  BACKOFFICE_CAMPAIGNS = '/admin/campanhas',
  BACKOFFICE_CAMPAIGN_DETAILS = '/admin/campanhas/:id',
  BACKOFFICE_WEBISODES = '/admin/webisodes',
  BACKOFFICE_WEBISODE_DETAILS = '/admin/webisodes/:id',
  BACKOFFICE_TRAININGS = '/admin/formacoes',
  BACKOFFICE_TRAINING_DETAILS = '/admin/formacoes/:id',
  BACKOFFICE_SLIDERS = '/admin/sliders',
  BACKOFFICE_SETTINGS = '/admin/settings',
  BACKOFFICE_PAGES = '/admin/paginas',
  BACKOFFICE_PAGE_DETAILS = '/admin/paginas/:id',
}
